import { UpdateQueryString, startSearch, resetToFirstPage, haiveFind } from "./search";

export default () => {
    var search = require('./search');
        

    // $("html").on("keypress", "#searchheader__inputfield", function(e) {
    //     if (e.keyCode == 13 && $(this).val().length > 0) {
    //         e.preventDefault();
    //         parent.location = "/search/" + $(this).val() + "?sok=" + $(this).val();
    //     }
    // });
    // $("html").on("click", ".searchheader__search-button", function(e) {
    //     parent.location = "/search/" + $(".searchheader__inputfield").val() + "?sok=" + $(".searchheader__inputfield").val();
    // });
    
    
    // //Category group header Click
    // $("html").on("click", ".categories__listheader", function(e) {
    //     $(this).toggleClass("closed");
    //     $(this).parent().find(".categories__listgroup").toggle();
    // });
    // //Category click
    // $("html").on("click", ".categories__listitem input", function(e) {
    //     filterText = "";
    //     $.each($("input.categories__listcheck:checked"), function() {
    //         filterText += $(this).attr("data-category_select") + ";";
    //     });
    //     UpdateQueryString("filter", filterText);
    //     resetToFirstPage()
    //     haiveFind(query__text, filterText);
    // });
    //click sort order dropdown
    // document.querySelector(".searchresult__meta__dropdown-button").addEventListener("click", button => {
    //     button.currentTarget.classList.toggle("open");
    //     button.currentTarget.nextElementSibling.classList.toggle("d-block");
    // });
    // //Click selected sort order
    // document.querySelector(".searchresult__meta__dropdown-content span").addEventListener("click", button => {
    //     sort__order = button.currentTarget.innerText == "Dato" ? "DATE" : "RELEVANCE";
    //     UpdateQueryString("sort__order", search.sort__order);
    //     resetToFirstPage();
    //     haiveFind(search.query__text, search.filterText);
    //     $(".searchresult__meta__dropdown-button").classList.toggle("open");
    //     $(".searchresult__meta__dropdown").find(".dropdown-menu").toggle();
    // });

    // //Pagination button click
    // $("html").on("click", ".searchresult__pagination a", function(e) {
    //     if ($(this).hasClass("searchresult__prev__page")) {
    //         hits__from = Number(prev__page);
    //     }
    //     else if ($(this).hasClass("searchresult__next__page")) {
    //         hits__from = Number(next__page);
    //     }
    //     prev__page = Number(hits__from) - Number(hits__pr__page);
    //     next__page = Number(hits__from) + Number(hits__pr__page);

    //     UpdateQueryString("hits__from", hits__from);
    //     haiveFind(query__text, filterText);
    //     var elmnt = document.getElementById("mainCol");
    //     elmnt.scrollIntoView();
    // });



    
    
    // console.log("PPPPPPPPPOoost render");
    document.getElementById("searchheader__inputfield").addEventListener("keyup", key => {
        
        const field = document.getElementById("searchheader__inputfield");
        const value = field.value;
        
        // console.log("value", value);
        
        if(key.key === "Enter") {
            // UpdateQueryString("q",value);
            if(!site.includes("/sok/?q=")) {
                parent.location = site + "/sok/?q=" + value;
            }
            // startSearch(value);
        }
        
        
        // startSearch(value);
    });
    
    document.getElementById("searchheader__button").addEventListener("click", button => {
       
       
        const field = document.getElementById("searchheader__inputfield");
        const value = field.value;
        
        parent.location = "?sok/?q=" + value;
        
    });
    
    
  document.querySelectorAll(".categories__listheaderlink").forEach(accordian => {
      
    //   console.log("rtest");
     
        // accordian.addEventListener("click", () => {
            
            
        //       const nextContent = accordian.nextSibling;
        //     console.log("click", nextContent.style);
        //     //   nextContent.style;
        // }, false)
        
  });
    
  if(window.innerWidth < 676){
      document.querySelectorAll(".categories__listheaderlink").forEach(item => {
         item.classList.add("closed");
      });
      document.querySelectorAll(".categories__listgroup").forEach(item => {
         item.classList.add("categories__listgroup-closed"); 
      });
      //.
  }
    
    
}